<template>
<div class="chapter">
<div class="inner_page">
<h1 class="center" id="TOC">Contents</h1>
<p class="toc1" style="margin-top:20px;"><a href="#/5start#chap1">Foreword</a></p>
<p class="toc1"><a href="#/6chap2#chap2">Chapter One Warm-up</a></p>
<p class="toc1"><a href="#/7chap3#chap3">Chapter Two Hit and Run</a></p>
<p class="toc1"><span href="#/8chap4#chap4" title="Link target outside of Sample">Chapter Three Squeeze</span></p>
<p class="toc1"><span href="#/9chap5#chap5" title="Link target outside of Sample">Chapter Four Errors</span></p>
<p class="toc1"><span href="#/10chap6#chap6" title="Link target outside of Sample">Chapter Five Road Trip</span></p>
<p class="toc1"><span href="#/11chap7#chap7" title="Link target outside of Sample">Chapter Six Curveball</span></p>
<p class="toc1"><span href="#/12chap8#chap8" title="Link target outside of Sample">Chapter Seven Hot Corner</span></p>
<p class="toc1"><span href="#/13chap9#chap9" title="Link target outside of Sample">Chapter Eight Rundown</span></p>
<p class="toc1"><span href="#/14chap10#chap10" title="Link target outside of Sample">Chapter Nine Five O’Clock Lightning</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 4TOC.vue?56f2bd74